import React, { useState, useEffect } from 'react';
import './JoinRequestModal.css';

function JoinRequestModal({ host, onClose, onSubmitRequest, userLanguages }) {
  const [numGuests, setNumGuests] = useState(1);
  const [message, setMessage] = useState('');
  const [needs, setNeeds] = useState('');
  const [languages, setLanguages] = useState('');

  useEffect(() => {
    if (userLanguages && !languages) {
      setLanguages(userLanguages);
    }
  }, [userLanguages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const requestData = {
      hostId: host.id,
      numGuests,
      message,
      needs,
      languages,
    };
    onSubmitRequest(requestData);
  };

  if (!host) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content join-request-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2>Request to join this Shabbat dinner</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="numGuests">How many guests?</label>
            <select id="numGuests" value={numGuests} onChange={(e) => setNumGuests(parseInt(e.target.value, 10))}>
              {[...Array((host.dinnerDetails?.maxGuests || host.maxGuests || 4))].map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">Tell the host a little about yourselves</label>
            <textarea
              id="message"
              rows="4"
              placeholder="e.g. We're two friends studying in Germany. We'd love to join your Shabbat dinner and meet new people!"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="needs">Anything the host should know?</label>
            <input
              type="text"
              id="needs"
              placeholder="(allergies, dietary needs, accessibility requests)"
              value={needs}
              onChange={(e) => setNeeds(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="languages">Languages you speak:</label>
            {/* Basic input for now, could be improved */}
            <input
              type="text"
              id="languages"
              value={languages}
              onChange={(e) => setLanguages(e.target.value)}
            />
             {/* Consider adding a dropdown based on common languages or host languages */}
          </div>

          <div className="modal-footer">
            <button type="submit" className="send-request-button">Send Request</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default JoinRequestModal; 